'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRules$002dPage$0024 from "./presto.-List-Rules-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485 from "./presto.-Presto-Router$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$84() {
  this.bom = null;
  this.boe = null;
  this.bof = false;
  this.bon = null;
  this.boo = false;
  this.bor = null;
  this.bok = null;
  this.bol = false;
  this.bog = null;
  this.boh = false;
  this.boi = null;
  this.boj = false;
  this.bop = false;
  this.boq = false;
  this.bom = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bor = "ListRulesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$84 as $c_Lpresto_PrestoRouter$$anon$84 };
$p = $c_Lpresto_PrestoRouter$$anon$84.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$84;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$84() {
}
export { $h_Lpresto_PrestoRouter$$anon$84 as $h_Lpresto_PrestoRouter$$anon$84 };
$h_Lpresto_PrestoRouter$$anon$84.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bom;
});
$p.L = (function() {
  if ((!this.bof)) {
    this.boe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bof = true;
  }
  return this.boe;
});
$p.O = (function() {
  if ((!this.boo)) {
    this.bon = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boo = true;
  }
  return this.bon;
});
$p.E = (function() {
  return this.bor;
});
$p.t = (function() {
  if ((!this.bol)) {
    this.bok = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bol = true;
  }
  return this.bok;
});
$p.M = (function() {
  if ((!this.boh)) {
    this.bog = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boh = true;
  }
  return this.bog;
});
$p.Q = (function() {
  if ((!this.boj)) {
    this.boi = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485.$c_Lpresto_PrestoRouter$$anon$85();
    this.boj = true;
  }
  return this.boi;
});
$p.w = (function() {
  if ((!this.boq)) {
    this.bop = false;
    this.boq = true;
  }
  return this.bop;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee549) => ((p) => \u03b4scrutinee549))($j_presto$002e$002dList$002dRules$002dPage$0024.$m_Lpresto_ListRulesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$84 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$84, "presto.PrestoRouter$$anon$84", ({
  OT: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$84 as $d_Lpresto_PrestoRouter$$anon$84 };
//# sourceMappingURL=presto.-Presto-Router$$anon$84.js.map
